const AWS_URL = (!window.location.href.includes('wearefriends.cool')) ?  'https://staging-web.wearefriends.cool' : window.location.href.includes('staging') ? 'https://staging-web.wearefriends.cool' : 'https://wearefriends.cool';

const MediaService = {
  getImage(path, login) {
    return `${AWS_URL}/images${path}${login.cookie}`;
  },
  getVideo(path, login) {
    return `${AWS_URL}/media${path}${login.cookie}`;
  },
};

export default MediaService;
